import { useState } from "react"
import { useTheme } from "@mui/material"

import type { AlertSettingAccordion } from "types/alerts.types"
import { Accordion, AccordionDetails, AccordionSummary } from "widgets/styled/widgets"
import AlertAccordionSummaryContent from "widgets/alerts/AlertAccordionSummaryContent"
import AlertAccordionDetailsContent from "widgets/alerts/AlertAccordionDetailsContent"
import useSetAlertSettingActive from "widgets/alerts/settings/useSetAlertSettingActive"

interface AlertAccordionProps {
  alert: AlertSettingAccordion
  hideEntity?: boolean
}

function AlertAccordion({ alert, hideEntity }: AlertAccordionProps) {
  const [details, setDetails] = useState(false)
  const [expanded, setExpanded] = useState(false)
  const theme = useTheme()
  const { setActive, isLoading: isSettingActive } = useSetAlertSettingActive(alert)

  const toggle = () => {
    setDetails(true)
    setExpanded((open) => !open)
  }

  return (
    <Accordion
      variant="outlined"
      state={alert.state}
      expanded={expanded}
      onChange={toggle}
    >
      {/* The chevron lives in the content, so on mobile it can share the name's row. */}
      <AccordionSummary
        state={alert.state}
        sx={{
          pointerEvents: "none",
          [theme.breakpoints.down("md")]: { p: "0.5rem" },
        }}
      >
        <AlertAccordionSummaryContent
          alert={alert}
          hideEntity={hideEntity}
          expanded={expanded}
          onToggle={toggle}
          setActive={setActive}
          isSettingActive={isSettingActive}
        />
      </AccordionSummary>
      {details && (
        <AccordionDetails
          state={alert.state}
          sx={{ [theme.breakpoints.down("md")]: { p: "0.5rem" } }}
        >
          <AlertAccordionDetailsContent
            alert={alert}
            setActive={setActive}
            isSettingActive={isSettingActive}
          />
        </AccordionDetails>
      )}
    </Accordion>
  )
}

export default AlertAccordion
